import { DIALCODE } from '../constants/types';

export const setDialCode = (dialcode) => ({
  type: DIALCODE,
  dialcode: dialcode
});